import { ModalController } from 'react-modal-global';

import VModalCatalog from './Catalog/VModalCatalog';
// Contacts
import VModalContacts from './Contacts/VModalContacts';
// Service Page - Details
import VServicesModalCleaningDetails from '../../pages/services/modals/cleaning/VServicesModalCleaningDetails';
import VServicesModalDeliveryDetails from '../../pages/services/modals/delivery/VServicesModalDeliveryDetails';
import VServicesModalRecycleDetails from '../../pages/services/modals/recycle/VServicesModalRecycleDetails';
import VServicesModalRentDetails from '../../pages/services/modals/rent/VServicesModalRentDetails';
import VServicesModalRepairDetails from '../../pages/services/modals/repair/VServicesModalRepairDetails';
import VServicesModalReturnDetails from '../../pages/services/modals/return/VServicesModalReturnDetails';
// // Service Page - Orders
import VServicesModalRepairOrder from '../../pages/services/modals/repair/VServicesModalRepairOrder';
// Payment Processing
import VProcessingPayment from '../../pages/services/modals/processing/VProcessingPayment';
// Login
import VModalLogin from './Login/VModalLogin';
// News Page
import VNewsModal from '../../pages/news/VNewsModal';
// Vacancies
import VVacanciesModalDetails from '../../pages/vacancies/VVacanciesModalDetails';
import VVacanciesModalApply from '../../pages/vacancies/VVacanciesModalApply';


const Modal_1 = new ModalController({
  defaultParams: {},
  components: {
                VModalContacts,
                VModalCatalog,
                VModalLogin,
                VNewsModal,
                VVacanciesModalDetails,
                VVacanciesModalApply,
                // Services - Details
                VServicesModalCleaningDetails,
                VServicesModalDeliveryDetails,
                VServicesModalRecycleDetails,
                VServicesModalRentDetails,
                VServicesModalRepairDetails,
                VServicesModalReturnDetails,
                // Services - Orders
                VServicesModalRepairOrder,
                // Payment Processing
                VProcessingPayment,
              },
});

export default Modal_1;
